var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup105(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9756 8.92683V20.1057C21.9756 20.3429 21.8821 20.5703 21.7156 20.7381C21.5491 20.9058 21.3232 21 21.0878 21H1.99884C1.73393 21 1.47987 20.894 1.29255 20.7053C1.10523 20.5166 1 20.2607 1 19.9939V5.90853C1 5.6417 1.10523 5.38579 1.29255 5.19711C1.47987 5.00843 1.73393 4.90244 1.99884 4.90244H7.65892C7.87504 4.90244 8.08533 4.97304 8.25823 5.10365L11.7209 7.71951C11.8938 7.85012 12.1041 7.92073 12.3202 7.92073H20.9768C21.2417 7.92073 21.4957 8.02673 21.6831 8.21541C21.8704 8.40409 21.9756 8.65999 21.9756 8.92683Z",
    stroke: "#979797",
    strokeWidth: 1.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90247 5.02439V2.0061C4.90247 1.73926 5.0077 1.48336 5.19502 1.29468C5.38234 1.106 5.6364 1 5.9013 1H11.5614C11.7775 1 11.9878 1.07061 12.1607 1.20122L15.6233 3.81707C15.7962 3.94769 16.0065 4.01829 16.2226 4.01829H24.8792C25.1441 4.01829 25.3982 4.12429 25.5855 4.31297C25.7728 4.50165 25.8781 4.75756 25.8781 5.02439V16.2033C25.8781 16.3207 25.8551 16.437 25.8105 16.5455C25.7659 16.654 25.7005 16.7526 25.618 16.8356C25.5356 16.9187 25.4377 16.9845 25.33 17.0295C25.2223 17.0744 25.1068 17.0976 24.9902 17.0976H21.8827",
    stroke: "#979797",
    strokeWidth: 1.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup105);
export default __webpack_public_path__ + "static/media/Group 105.767c9e1f5292017c634f9e3e27c75b98.svg";
export { ForwardRef as ReactComponent };